// custom code start
(function () {
  if (window.Tracking && window.Tracking.init && window.Tracking.init.promotion) return;
  var Tracking = window.Tracking || (window.Tracking = {});
  Tracking.init = Tracking.init || {};
  Tracking.init.promotion = true;

  function readPromotion(el) {
    return {
      creative_name: el.getAttribute('data-creative-name') || '',
      creative_slot: el.getAttribute('data-creative-slot') || '',
      promotion_id: el.getAttribute('data-promotion-id') || '',
      promotion_name: el.getAttribute('data-promotion-name') || '',
      location_id: el.getAttribute('data-location-id') || location.pathname,
    };
  }

  function readPromotionItems(el) {
    var islandId = el.getAttribute('data-promo-items');
    if (!islandId) return null;
    var node = document.getElementById(islandId);
    if (!node) return null;
    try {
      var items = JSON.parse(node.textContent);
      return Array.isArray(items) && items.length > 0 ? items : null;
    } catch (e) {
      return null;
    }
  }

  function push(payload) {
    if (typeof Tracking.push === 'function') {
      Tracking.push(payload);
    } else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
    }
  }

  function emit(eventName, el) {
    var ecommerce = readPromotion(el);

    // Both view_promotion and select_promotion carry the products, so a
    // promotion is always tied to the items it surfaced. The promotion doubles
    // as a list: a product first met in a banner is attributed to that banner
    // for the rest of the session (Tracking.applyAttribution locks it in).
    var items = readPromotionItems(el);
    if (items) {
      var listId = el.getAttribute('data-tracking-list-id') ||
        ('promo_' + (ecommerce.promotion_id || ''));
      var listName = el.getAttribute('data-tracking-list-name') ||
        ecommerce.promotion_name || '';

      items.forEach(function (item) {
        if (!item.item_list_id) {
          item.item_list_id = listId;
          item.item_list_name = listName;
        }
      });

      ecommerce.items = items;
      ecommerce.item_list_id = listId;
      ecommerce.item_list_name = listName;
    }

    push({ event: eventName, ecommerce: ecommerce });
  }

  function observeImpressions() {
    var banners = document.querySelectorAll('[data-promotion-id]:not([data-promotion-id=""])');
    if (!banners.length) return;

    var firedElements = new WeakSet();
    var firedPromotionIds = new Set();

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        if (firedElements.has(entry.target)) return;
        firedElements.add(entry.target);

        var promotionId = entry.target.getAttribute('data-promotion-id');
        if (firedPromotionIds.has(promotionId)) {
          observer.unobserve(entry.target);
          return;
        }
        firedPromotionIds.add(promotionId);

        emit('view_promotion', entry.target);
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.5 });

    banners.forEach(function (banner) { observer.observe(banner); });
  }

  function bindClicks() {
    document.addEventListener('click', function (e) {
      var actionable = e.target.closest && e.target.closest('a, button');
      if (!actionable) return;
      var banner = actionable.closest('[data-promotion-id]:not([data-promotion-id=""])');
      if (!banner) return;
      emit('select_promotion', banner);
    }, true);
  }

  function init() {
    observeImpressions();
    bindClicks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
// custom code end
